// import { ANIMATE } from '@namespace/top/animate'
// import { VIDEO } from '@namespace/top/video'
import { TAB } from '@namespace/top/tab'

export default function top() {
  window.addEventListener('load', () => {
    // ANIMATE.init()
    // VIDEO.init()
    TAB.init()
  })
}
